module.exports = __webpack_public_path__ + "static/pdp3-8ba2555b094e313b9edfac95ec33f787.png";